import React from 'react';
import { APP_CONTAINER_ROUTES } from '@/navigators/routes';
import { AppContainerStackParams } from '@/navigators/types';
import { InvoiceDetailComponent } from './invoice-detail-component';
import { StackScreenProps } from '@react-navigation/stack';

type Props = StackScreenProps<
  AppContainerStackParams,
  APP_CONTAINER_ROUTES.InvoiceDetail
>;

export const InvoiceDetailScreen: React.FC<Props> = ({ route }) => {
  const { invoiceUUID, renderPayable } = route.params;

  return (
    <InvoiceDetailComponent
      invoiceUUID={invoiceUUID}
      renderPayable={renderPayable}
    />
  );
};
